import {useState, useEffect} from 'react';
import {getTopStores} from '../../../APIs/auditor_dashboard';
import {useNavigate} from 'react-router-dom';

const useStoresRankingTable = (filters, setLoading, role) => {
    const [data, setData] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [storesData, setStoresData] = useState([]);
    const navigate = useNavigate();

    const storesRankingHeaders = [
        {value: 'رتبه'},
        {value: 'نام فروشنده'},
        {value: 'تعداد درخواست'},
        {value: 'مجموع خریدها'},
    ];

    const formatNumber = (num) => {
        return new Intl.NumberFormat('en-US').format(num);
    };

    const handleStoreClick = (storeName) => {
        navigate(`/${role}`, {
            state: {
                searchCategory: 'seller',
                searchQuery: storeName,
            }
        });
    };

    const fetchTopStores = async () => {
        try {
            setLoading(true);
            const response = await getTopStores(filters);
            setData(response.data);
            setDataLoaded(true);
        } catch (error) {
            console.error('Error fetching top stores:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTopStores();
    }, [filters]);

    useEffect(() => {
        if (dataLoaded) {
            const rankingData = Object.keys(data).map((category, index) => {
                const {count, total_price_sum} = data[category];
                return [
                    {value: (index + 1).toString()},
                    {
                        value: role === 'user'
                            ? category
                            : (
                                <span
                                    style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "var(--primary-light-color)"
                                    }}
                                    onClick={() => handleStoreClick(category)}
                                >
                                    {category}
                                </span>
                            )
                    },
                    {value: formatNumber(count)},
                    {value: `${formatNumber(total_price_sum)} ریال`},
                ];
            });

            setStoresData(rankingData);
            setDataLoaded(false);
        }
    }, [data, dataLoaded]);

    return {storesRankingHeaders: storesRankingHeaders, storesRankingData: storesData};
};

export default useStoresRankingTable;
